function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLeftShape(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 755,
    height: 1349.89,
    viewBox: "0 0 755 1349.89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M357.763 0H.556v295.46l609.232-.608L.556 940.918v408.973h1.75l667.251-704.36 4.627-6.076a394.915 394.915 0 0 0 81.372-241.306C755.556 178.607 577.106 0 357.763 0",
    id: "shapePath",
    transform: "translate(-.556 -.001)",
    style: {
      fill: "#fff",
      opacity: 0.04
    }
  }));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftShape);
export default __webpack_public_path__ + "static/media/left-shape.328efc0469f6ca03106a5fe2074fc119.svg";
export { ForwardRef as ReactComponent };